export default class Holdings {
  constructor() {
    this.tickers = [];
  }
}
